import * as Cons from "../utils/Constants"
import axios from 'axios'
// export const setGetUserInfoFetchingToState = () => ({
//   type: Cons.GET_USER_INFO_FETCHING,
// })

export const setGetUserInfoDataToState = (payload) => ({
  type: Cons.GET_USER_INFO_DATA,
  payload,
})

export const setGetUserInfoFailedToState = () => ({
    type: Cons.GET_USER_INFO_FAILED,
})

export const GetUserInformation = (data) => {
    // const authentication = AuthenticationService();
    console.log('data', data)
    return async (dispatch) => {
        try {
            // const authentication = AuthenticationService();
            // dispatch(setGetUserInfoFetchingToState())
            // const resultMenuList = await authentication.getMenuList(data);
            // const resultMenuList = await axios.post(`http://qas-wrmngsvcwebapi-core.homepro.local/api/authentication/menulist/list`,data);
            dispatch(setGetUserInfoDataToState(data))
        } catch (error) {
            console.log('error', error)
            dispatch(setGetUserInfoFailedToState())
        }
    }
}